import { define } from 'wicked-elements'
import onIntersect from 'on-intersect'

define('[data-component~="ultralazy"]', {
  init () {
    this.state = {}
    this.options = {...this.element.dataset}
    this.onEnter = this.onEnter.bind(this)
    this.onLoad = this.onLoad.bind(this)
  },
  connected () {
    if (!this.options.manual) {
      this.stopObserving = onIntersect(this.element, {}, this.onEnter)
    }
  },
  disconnected () {
    if (!this.options.manual) {
      this.stopObserving()
    }
  },
  onEnter (e) {
    this.loadImg()
    this.stopObserving()
  },
  loadImg () {
    this.element.classList.replace('lazyload', 'lazyloading')

    const newSrcset = this.element.dataset.srcset
    if (newSrcset) {
      if (this.element.dataset.sizes === 'auto' && this.element.offsetWidth) {
        this.element.sizes = `${this.element.offsetWidth}px`
      }
      this.element.srcset = newSrcset
    }

    const newSrc = this.element.dataset.src
    if (newSrc) this.element.src = newSrc
  },
  onLoad () {
    if (this.element.classList.contains('lazyloading')) {
      this.element.classList.replace('lazyloading', 'lazyloaded')
    }
  },
  onTriggerLoad () {
    const classList = this.element.classList
    if (!classList.contains('lazyloading') && !classList.contains('lazyloaded')) {
      this.loadImg()
    }
  }
})